import axios, { AxiosResponse } from "axios";
import { DealAuditEventDto, CreateDealAuditEventDto } from "./dtos/DealAuditEventDto";
import { appConfig } from "../config/keycloak";

/**
 * Service to handle Deal Audit Event operations
 */
class DealAuditEventService {
    private readonly api = axios.create({
        baseURL: appConfig.baseUrl  
    });

    constructor() {
        // Empty constructor, configuration is in the api instance
    }

    /**
     * Create a new deal audit event
     * POST /api/v1/deals/{privateId}/audit-events
     * 
     * @param token - Authorization token
     * @param privateId - Deal private ID (from URL path)
     * @param dealAuditEventDto - The audit event data to create
     * @returns Promise with the created audit event response (status 201)
     * @throws Error if the audit event already has an ID (status 400)
     */
    public createDealAuditEvent(
        token: string,
        privateId: string,
        dealAuditEventDto: CreateDealAuditEventDto
    ): Promise<AxiosResponse<DealAuditEventDto>> {
        return this.api.post(
            `/deal-service/api/v1/deals/${privateId}/audit-events`,
            dealAuditEventDto,
            { headers: { Authorization: `Bearer ${token}` } }
        );
    }
}

export default new DealAuditEventService();
